import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fixedassetnewreq',
  templateUrl: './fixedassetnewreq.component.html',
  styleUrls: ['./fixedassetnewreq.component.css']
})
export class FixedassetnewreqComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
